import React from 'react';
import './styles.scss';
import { Person } from '#root/queries/persons';
import { PERSON_ENUMS, PERSON_TYPES } from '#root/utils/persons';
import { getEnumLabelByValue, getUnitEnumLabelByValue } from '#root/utils/enums';
import LazyImage from '#root/components/LazyImage';

interface PersonCardProps {
  person: Person;
  unit?: string;
}

export const PersonCard: React.FC<PersonCardProps> = ({
  person,
  unit
}) => {

  return (
    <div className="person-card__content">
      <div className="person-image">
        <LazyImage
          src={person.pictureUrl}
          alt={person.fullName || 'Victim'}
          fallback={<div className="person-image--no-image" />}
        />
      </div>
      <div className="person-header">
        <span className="person-name">{person.fullName}</span>
        <div className="person-divider"></div>
        <span className="person-incident">{person.incidentName || 'Unknown Incident'}</span>
      </div>
      <div className="person-details">
        <div className="person-row">
          <div className="person-field">
            <span className="large-card__label">Gender: </span>
            <span className="large-card__value">{getEnumLabelByValue(PERSON_ENUMS.GENDER, person.gender)}</span>
          </div>
          <div className="person-divider"></div>
          <div className="person-field">
            <span className="large-card__label">Age: </span>
            <span className="large-card__value">{getUnitEnumLabelByValue(PERSON_ENUMS.AGE_RANGES, person.age, unit) || '-'}</span>
          </div>
          <div className="person-divider"></div>
          <div className="person-field">
            <span className="large-card__label">Height: </span>
            <span className="large-card__value">{getUnitEnumLabelByValue(PERSON_ENUMS.HEIGHT_RANGES, person.height, unit) || '-'}</span>
          </div>
          <div className="person-divider"></div>
          <div className="person-field">
            <span className="large-card__label">Weight: </span>
            <span className="large-card__value">{getUnitEnumLabelByValue(PERSON_ENUMS.WEIGHT_RANGES, person.weight, unit) || '-'}</span>
          </div>
        </div>
        <div className="person-row">
          <div className="person-field">
            <span className="large-card__label">Hair: </span>
            <span className="large-card__value">{getEnumLabelByValue(PERSON_ENUMS.HAIR_COLORS, person.hair)}</span>
          </div>
          <div className="person-divider"></div>
          <div className="person-field">
            <span className="large-card__label">Eyes: </span>
            <span className="large-card__value">{getEnumLabelByValue(PERSON_ENUMS.EYE_COLORS, person.eyes)}</span>
          </div>
          <div className="person-divider"></div>
          <div className="person-field">
            <span className="large-card__label">Features: </span>
            <span className="large-card__value">{person.features?.map(feature => getEnumLabelByValue(PERSON_ENUMS.FEATURES, feature)).join(', ') || 'None'}</span>
          </div>
        </div>
        {person.locationAddress && person.type === PERSON_TYPES.VICTIM && (
          <div className="person-row">
            <div className="person-field">
              <span className="large-card__label">Was Left at Location: </span>
              <span className="large-card__value">{person.locationAddress}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
